import Axios from 'axios';
import Qs from 'qs';

export default {

  // 组织目录
  companyList() {
    return Axios.get('/property/api/admin/tissue');
  },

  // 组织员工目录
  companyStaffList() {
    return Axios.get('/property/api/admin/tissue-staff');
  },

  //新增组织部门
  addDepartment(
    name,
    parent_id
  ) {
    let params = {};
    params.name = name;
    if (parent_id) {
      params.parent_id = parent_id;
    }
    return Axios.post('/property/api/admin/tissue', params);
  },

  //编辑组织部门
  editDepartment(
    id,
    name
  ) {
    return Axios.patch(`/property/api/admin/tissue/${id}`, {
      name
    });
  },

  //删除组织部门
  deleteDepartment(
    id
  ) {
    return Axios.delete(`/property/api/admin/tissue/${id}`);
  },

  // 修改组织部门上级
  changeDepartmentSuperior(
    id,
    tissue_up_id
  ) {
    return Axios.patch(`/property/api/admin/tissue/${id}/move-up`, {
      tissue_up_id
    });
  },

  // 员工分页列表
  staffListPage(
    id,
    name,
    phone_number,
    position,
    page,
    limit
  ) {
    return Axios.get('/property/api/admin/staff', {
      params: {
        search_tissue: {
          tissue_id: id
        },
        filter: {
          name,
          phone_number,
          position
        },
        page,
        limit
      },
      paramsSerializer(params) {
        return Qs.stringify(params);
      }
    });
  },

  // 添加员工
  addStaff(
    name,
    sex,
    image_url,
    phone_number,
    job_number,
    tissue_id,
    position
  ) {
    return Axios.post('/property/api/admin/staff', {
      name,
      sex,
      image_url,
      phone_number,
      job_number,
      tissue_id,
      position
    });
  },

  // 编辑员工
  editStaff(
    id,
    name,
    sex,
    image_url,
    phone_number,
    job_number,
    tissue_id,
    position
  ) {
    return Axios.patch(`/property/api/admin/staff/${id}`, {
      name,
      sex,
      image_url,
      phone_number,
      job_number,
      tissue_id,
      position
    });
  },

  // 删除员工
  deleteStaff(
    id
  ) {
    return Axios.delete(`/property/api/admin/staff/${id}`);
  },

  staffInfo(
    id
  ) {
    return Axios.get(`/property/api/admin/staff/${id}`)
  }

}